import React from 'react';
import GoogleAnalytics from './GoogleAnalytics';
import FacebookPixel from './FacebookPixel';

interface AnalyticsConfigProps {
  googleAnalyticsId?: string;
  facebookPixelId?: string; // Single pixel (legacy)
  facebookPixelIds?: string[]; // Multiple pixels
}

const AnalyticsConfig: React.FC<AnalyticsConfigProps> = ({
  googleAnalyticsId = 'YOUR_GA4_MEASUREMENT_ID',
  facebookPixelId = 'YOUR_FACEBOOK_PIXEL_ID',
  facebookPixelIds
}) => {
  return (
    <>
      {googleAnalyticsId && googleAnalyticsId !== 'YOUR_GA4_MEASUREMENT_ID' && (
        <GoogleAnalytics measurementId={googleAnalyticsId} />
      )}
      {(facebookPixelIds || facebookPixelId) && (
        <FacebookPixel 
          pixelId={facebookPixelId !== 'YOUR_FACEBOOK_PIXEL_ID' ? facebookPixelId : undefined}
          pixelIds={facebookPixelIds}
        />
      )}
    </>
  );
};

export default AnalyticsConfig;